import { Component, OnInit, Input } from '@angular/core';
import { Company } from 'src/app/shared/models/Company';
import { Option } from 'src/app/shared/select/select.component';
import { Country } from 'src/app/shared/models/Country';
import { Client } from 'src/app/shared/models/Client';

@Component({
    selector: 'app-company-tab',
    templateUrl: './company-tab.component.html',
    styleUrls: ['./company-tab.component.scss'],
    standalone: false
})
export class CompanyTabComponent implements OnInit {

  @Input()
  company: Company;

  @Input()
  client: Client;

  @Input()
  countrySelectOptions: Option[];

  @Input()
  createNewClientEnv: boolean;

  @Input()
  countryObjects: Country[];

  public countryId = 1;

  constructor() {
    if (this.company.country.id) {
      this.countryId = this.company.country.id;
    }
  }

  ngOnInit() {
  }

  changeCountry() {
    this.company.country = this.countryObjects.filter(country => country.id === this.countryId)[0];
  }

}
